
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { StudentFormValues } from "../schema/studentSchema";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useIsMobile } from "@/hooks/use-mobile";
import { useTranslations } from "@/hooks/useTranslations";

interface PreferencesTabProps {
  form: UseFormReturn<StudentFormValues>;
}

export const PreferencesTab = ({ form }: PreferencesTabProps) => {
  const isMobile = useIsMobile();
  const { t } = useTranslations("students");
  
  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="preferred_training_type"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t("form.preferredTrainingType")}</FormLabel>
            <Select 
              onValueChange={field.onChange} 
              defaultValue={field.value}
              value={field.value}
            >
              <FormControl>
                <SelectTrigger className="text-muted-foreground">
                  <SelectValue placeholder={t("form.selectTrainingType")} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="musculacao">{t("form.trainingTypes.strength")}</SelectItem>
                <SelectItem value="funcional">{t("form.trainingTypes.functional")}</SelectItem>
                <SelectItem value="cardio">{t("form.trainingTypes.cardio")}</SelectItem>
                <SelectItem value="hiit">{t("form.trainingTypes.hiit")}</SelectItem>
                <SelectItem value="pilates">{t("form.trainingTypes.pilates")}</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="preferred_training_time"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t("form.preferredTrainingTime")}</FormLabel>
            <Select 
              onValueChange={field.onChange} 
              defaultValue={field.value}
              value={field.value}
            >
              <FormControl>
                <SelectTrigger className="text-muted-foreground">
                  <SelectValue placeholder={t("form.selectTrainingTime")} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="manha">{t("form.trainingTimes.morning")}</SelectItem>
                <SelectItem value="tarde">{t("form.trainingTimes.afternoon")}</SelectItem>
                <SelectItem value="noite">{t("form.trainingTimes.evening")}</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="goals"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t("form.goals")}</FormLabel>
            <FormControl>
              <Textarea 
                placeholder={t("form.goals")} 
                {...field} 
                className="resize-none min-h-[100px]"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="notes"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t("form.additionalNotes")}</FormLabel>
            <FormControl>
              <Textarea 
                placeholder={t("form.additionalNotes")} 
                {...field} 
                className="resize-none min-h-[100px]"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
